import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ResetPasswordModel } from "../../../common/utils";

const initialState: ResetPasswordModel = {
  resetPasswordmessage: "",
};

const forgetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    setMessage: (
      state: ResetPasswordModel,
      action: PayloadAction<ResetPasswordModel>,
    ) => {
      state.resetPasswordmessage = action.payload.resetPasswordmessage;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMessage } = forgetPasswordSlice.actions;

export default forgetPasswordSlice.reducer;
